export enum ViewMode {
    DEFAULT,
    DRAGGING,
    ISSUE_ADD
}